import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MobiledataOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mobiledata_off"}/>
}
